import { TAssetInvestmentDetailsSchema } from '@brickwise/asset-validation/dist/asset/investmentData';
import { useFormikContext } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NormalDatepicker } from 'src/components/mui-overrides/Datepicker';

interface Props {
  disabled?: boolean;
}

export const MaturityDatePicker: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext<TAssetInvestmentDetailsSchema>();

  if (formik.values.investmentDetails?.maturity === true) {
    return (
      <NormalDatepicker
        disabled={disabled}
        label={t('dashboard.assets.addedit.investment.securitytype.fields.maturitydate')}
        fieldName="investmentDetails.maturityDate"
        formik={formik}
      />
    );
  }

  return <></>;
};
